import React from 'react';
import { GatsbyImage, IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import { VideoProps } from '.';

const ThumbnailImage = ({ videoFieldProps, field }: VideoProps) => {

    const alt = videoFieldProps.data.title || "Video Thumbnail";

    const thumbnailUrl = videoFieldProps.data.thumbnail?.url;
    const image = getImage(field.imageFile as IGatsbyImageData);

    if (!image) {
        return <img src={thumbnailUrl} alt={alt} className="absolute top-0 left-0 w-full h-full object-contain" />
    }

    return (
        <GatsbyImage image={image} alt={alt} className="absolute top-0 left-0 w-full h-full object-contain" />
    )
}

export default ThumbnailImage;